/**
 * Custom path function for react-d3-tree
 * Connects parent nodes to child nodes with a step pattern:
 * 1. Straight down from bottom-middle of parent
 * 2. Continue down to halfway point between parent and child
 * 3. Horizontal line to align with child's x position
 * 4. Straight down to top-middle of child
 */

// Node dimensions (matching D3TreeLeafNode)
const NODE_HEIGHT = 120 // height of the node
const NODE_HALF_HEIGHT = NODE_HEIGHT / 3 // 40px
const PARTNER_OFFSET = 110 // offset between parent and first partner

export const customPathFunc = (linkData) => {
    const { source, target } = linkData

    // Check if parent has partners
    const partners = source.data?.attributes?.partners || []
    const hasPartners = partners.length > 0

    // Calculate start X position
    // If parent has partners, start from midpoint between parent and first partner
    // Otherwise, start from center of parent node
    let startX = source.x
    let startY = source.y + NODE_HALF_HEIGHT

    if (hasPartners) {
        // First partner is at source.x + PARTNER_OFFSET
        // Midpoint is halfway between parent (source.x) and first partner
        startX = source.x + PARTNER_OFFSET / 2
        startY = source.y + 0
    }
        
    // Calculate halfway point between parent bottom and child top
    const parentBottom = source.y + NODE_HALF_HEIGHT
    const childTop = target.y - NODE_HALF_HEIGHT
    const midY = (parentBottom + childTop) / 2

    // End at top-middle of child node
    const endX = target.x
    const endY = target.y - NODE_HALF_HEIGHT

    // Create step path: down -> horizontal -> down
    return `M ${startX} ${startY} L ${startX} ${midY} L ${endX} ${midY} L ${endX} ${endY}`
}

export default customPathFunc

